/**
 * Supabase API Client
 *
 * Organized by domain for scalability and maintainability:
 * - Project: Lifecycle management (activate, pause, resume, delete)
 * - Database: SQL queries, tables, schema, CRUD operations
 * - Auth: User management, provider configuration
 * - Edge Functions: Deploy, list, delete, test functions
 * - Secrets: Secrets management for Edge Functions
 * - Storage: File storage and bucket management
 */

import { projectApi } from './project.api';
import { databaseApi } from './database.api';
import { authApi } from './auth.api';
import { edgeFunctionsApi } from './edge-functions.api';
import { secretsApi } from './secrets.api';
import { storageApi } from './storage.api';
import { debuggingApi } from './debugging.api';

/**
 * Unified API client (backwards compatible)
 * @deprecated Use domain-specific imports instead: projectApi, databaseApi, authApi, edgeFunctionsApi, secretsApi, storageApi
 */
export const supabaseApi = {
  // Project lifecycle
  ...projectApi,

  // Database operations
  ...databaseApi,

  // Auth management
  ...authApi,

  // Edge Functions
  ...edgeFunctionsApi,

  // Secrets
  ...secretsApi,

  // Storage
  ...storageApi,

  // Debugging (Advisors)
  ...debuggingApi,
};

// Export domain-specific APIs for better code organization
export { projectApi } from './project.api';
export { databaseApi } from './database.api';
export { authApi } from './auth.api';
export { edgeFunctionsApi } from './edge-functions.api';
export { secretsApi } from './secrets.api';
export { storageApi } from './storage.api';
export { debuggingApi } from './debugging.api';

// Export types
export type { SupabaseSecret } from './secrets.api';
export type { StorageBucket, StorageFile, CreateBucketOptions, BucketPolicy } from './storage.api';
